<template>
  <div class="body-container visitor-container">
    <div class="visitor-wrap">
      <div class="title">访客统计<van-icon @click="showIncomeNotice" name="question-o" /></div>
      <div class="visitor-box">
        <div class="visitor-box-item">
          <div>{{ queryCount.planCount }}</div>
          <div>计划书</div>
        </div>
        <div class="visitor-box-item">
          <div>{{ queryCount.airticleCount }}</div>
          <div>资讯文章</div>
        </div>
        <div class="visitor-box-item">
          <div>{{ queryCount.productCount }}</div>
          <div>产品</div>
        </div>
        <div class="visitor-box-item">
          <div>{{ queryCount.inviteLinkCount }}</div>
          <div>邀请链接</div>
        </div>
        <div class="visitor-box-item">
          <div>{{ queryCount.wecatStoreCount }}</div>
          <div>微店访客</div>
        </div>
      </div>
    </div>
    <van-pull-refresh v-model="refreshing" @refresh="onReferesh">
      <van-list v-if="list.length" v-model="loading" :finished="finished" finished-text="没有更多了" @load="nextPage">
        <div v-for="customer in list" :key="customer.id">
          <div class="list" @click="toDetail(customer, 1)">
            <div class="visitor-box">
              <div class="customer f">
                <img class="img-head" :src="customer.imgUrl" alt="" />
                <div class="content f-col">
                  <span>{{ customer.nickname }}</span>
                  <span>{{ customer.createTime | formatTime('MM-DD HH:mm') }}</span>
                </div>
                <span v-if="customer.time" class="time">阅读{{ customer.time }}</span>
              </div>
              <!-- 名片类型 -->
              <div class="info" v-if="customer.type == 7">查看了我的电子名片</div>
              <div class="info" v-else-if="customer.type == 8">查看了我的个人微店</div>
              <div class="info" v-else-if="customer.type == 10">查看了邀请链接</div>
              <div class="info" v-else-if="customer.type == 9">查看了我的预约顾问</div>
              <div class="info" v-else>查看了{{ VISIT_TYPE[customer.type] }}《{{ customer.name }}》</div>
              <span v-if="customer.customerId" class="tip">客户</span>
            </div>
          </div>
        </div>
      </van-list>
      <div v-else class="empty-box">
        <img src="@static/images/business/empty_3.png" alt="" />
        <p>暂无访客数据</p>
      </div>
    </van-pull-refresh>
  </div>
</template>
  
  <script>
  import { Dialog } from 'vant';
import { pageTools, common, loading } from '@/api/mixins';
export default {
  mixins: [pageTools, common, loading],
  data() {
    return {
      queryCount: {},
      list: [],
      isSearch: false,
      refreshing: false, //下拉刷新
      finished: true, //是否完成上拉加载
      searchParams: {
        //列表查询参数
        type: '', //访问类型 字典 key VISIT_TYPE 获取
        tabType: 1, //apptab栏类型,@notes1-按访客展示2-按内容展示
        pageSize: 20,
        pageNo: 1
      },
      totalNo: '' //总页数
    };
  },
  created() {
    this.getDicByType({
      type: 'VISIT_TYPE'
    }).then(res => {
      this.VISIT_TYPE = res;
    });
  },
  methods: {
    showIncomeNotice() {
      Dialog.alert({
        message: '统计范围为近一个月的访客数据'
      })
    },
    getOtherCount() {
      this.$http({
        url: '/app/visitRecord/queryCount',
        type: 'POST',
        data: {}
      }).then(res => {
        this.queryCount = res.data;
      });
    },
    toDetail(info, type) {
      if (type == 1) {
        //按访客
        this.$router.push({
          name: 'apps.business.visitorDetail',
          query: {
            visitorId: info.visitorId,
            type: this.searchParams.type
          }
        });
      } else {
        //按内容
        this.$router.push({
          name: 'apps.business.contentVisitDetail',
          query: {
            typeId: info.typeId,
            type: this.searchParams.type
          }
        });
      }
    },
    search() {
      this.searchParams.pageNo = 1;
      this.searchParams.tabType = 1;
      this.getOtherCount();
      this.getList(false);
    },
    //上拉加{载
    nextPage() {
      if (this.searchParams.pageNo == this.totalNo) {
        this.finished = true;
        return;
      }
      this.searchParams.pageNo++;
      this.getList(false);
    },
    //下拉刷新
    onReferesh() {
      this.refreshing = true;
      this.searchParams.pageNo = 1;
      this.searchParams.tabType = 1;
      this.getList(false);
    },
    getList(loading = true) {
      this.loading = loading;
      this.$http({
        type: 'POST',
        url: '/app/visitRecord/list',
        data: this.searchParams
      })
        .then(res => {
          this.searchParams.pageNo = res.current;
          this.totalNo = res.pages;
          if (res.current == 1) {
            this.list = [];
          }
          this.list = [...this.list, ...res.data].map(item => {
            if (item.visitTime) {
              item.time = this.$tools.formatSeconds(item.visitTime);
            }
            return item;
          });
          this.refreshing = false;
          this.loading = false;
          if (res.current === res.pages) {
            this.finished = true;
          } else {
            this.finished = false;
          }
        })
        .catch(() => {
          this.loading = false;
          this.refreshing = false;
          this.finished = true;
        });
    }
  }
};
</script>
  
  <style lang="scss" scoped>
  .van-icon-question-o {
    font-size: 32px;
    font-weight: 600;
    margin-left: 3px;
    transform: translateY(2px);
  }
.visitor-container {
  .empty-box {
    text-align: center;

    img {
      width: 420px;
      height: 180px;
      margin: 106px 0 40px;
    }

    font-size: 28px;
    line-height: 40px;
    color: #727c8e;
  }

  .list {
    .visitor-box {
      width: 690px;
      // height: 220px;
      background: rgba(255, 255, 255, 1);
      border-radius: 10px;
      margin: 20px auto;
      position: relative;
      padding-bottom: 20px;

      .customer {
        padding: 26px 32px 26px 28px;
        .img-head {
          flex: 0 0 86px;
          width: 86px;
          height: 86px;
          border-radius: 50%;
          margin-right: 14px;
          border-radius: 50%;
        }

        .content {
          flex: 1;

          & :first-child {
            font-size: 30px;
            line-height: 42px;
            color: #17233d;
          }

          & :last-child {
            font-size: 26px;
            line-height: 31px;
            color: #8e96a5;
            margin-top: 10px;
          }
        }

        .time {
          font-size: 26px;
          line-height: 31px;
          color: #727c8e;
          margin-right: 1px;
          margin-top: 50px;
        }
      }

      .info {
        font-size: 28px;
        line-height: 40px;
        max-height: 100px;
        color: #17233d;
        padding: 20px 30px 0px;
        border-top: 1px solid #ececec;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }

      .tip {
        position: absolute;
        width: 80px;
        height: 40px;
        background: linear-gradient(135deg, #23aaff 0%, #2378ff 100%);
        opacity: 1;
        border-radius: 0px 10px 0px 10px;
        font-size: 24px;
        line-height: 40px;
        color: #ffffff;
        text-align: center;
        right: 0;
        top: 0;
      }
    }
  }
  .f {
    display: flex;
    align-items: center;
  }

  .f-b {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .f-col {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .f-c {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  *[blue] {
    color: #236dff;
  }
  /deep/.van-list__finished-text {
    font-size: 24px;
    line-height: 33px;
    color: #aaaaaa;
    padding: 30px 0;
  }
  .visitor-wrap {
    margin: 30px auto 0px;
    width: 690px;
    height: 213px;
    background: #ffffff;
    box-shadow: 0px 3px 20px 1px rgba(253, 236, 220, 0.6);
    border-radius: 10px 10px 10px 10px;
    padding: 30px 34px 28px 30px;
    .title {
      font-weight: 600;
      font-size: 32px;
      color: #17233d;
      line-height: 45px;
      margin-bottom: 20px;
    }
    .visitor-box {
      display: flex;
      flex-direction: row;
      & > :last-child {
        &::after {
          display: none;
        }
      }
      .visitor-box-item {
        text-align: center;
        flex: 1;
        display: inline-block;
        position: relative;
        &::after {
          content: '';
          width: 0px;
          height: 70px;
          border-right: 1px solid #e5ecf5;
          position: absolute;
          right: 0;
          top: 0;
        }
        & > :first-child {
          font-weight: bold;
          font-size: 36px;
          color: #17233d;
          line-height: 40px;
          margin-bottom: 10px;
        }
        & > :last-child {
          font-size: 26px;
          color: #515a6e;
          line-height: 36px;
        }
      }
    }
  }
}
</style>
  